import React, { Component } from 'react';
import { asyncComponent } from 'react-async-component';
import PropTypes from 'prop-types';

const GoogleAnalytics = asyncComponent({
    resolve: () => import('./GoogleAnalytics'),
});

export default class GoogleAnalyticsSCWrapper extends Component {
    render() {
        return(
            <div>
                <GoogleAnalytics config={this.props.config} reportEvent={this.props.reportEvent(this.props.config.id)} />
            </div>
        );
    }
}

GoogleAnalyticsSCWrapper.propTypes = {
    config: PropTypes.object.isRequired,
};
